import dayjs from "dayjs";
/**
 * Русское описание результата `corp_generate_invoices` (WP-DSP-3-FIX, P-7): RPC не возвращает проверенный период,
 * он вычисляется по правилу сервера — последний **завершившийся** период (месяц/квартал по графику компании)
 * перед датой «по состоянию на» (МСК).
 */
const MSK_OFFSET_MS = 3 * 60 * 60 * 1000;
/** Календарная дата момента `asOf` по Москве как локальный dayjs (без плагинов utc/timezone). */
const mskDate = (iso) => {
    const shifted = new Date(new Date(iso).getTime() + MSK_OFFSET_MS);
    return dayjs(new Date(shifted.getUTCFullYear(), shifted.getUTCMonth(), shifted.getUTCDate()));
};
const fmt = (d) => d.format("DD.MM.YYYY");
const MONTHS = ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"];
export const lastCompletedPeriod = (asOfIso, billingPeriod) => {
    const asOf = mskDate(asOfIso);
    const unit = billingPeriod === "QUARTER" ? 3 : 1;
    // начало текущего периода (месяц или квартал), в который попадает дата as_of
    const monthIndex = asOf.month() - (asOf.month() % unit);
    const currentStart = dayjs(new Date(asOf.year(), monthIndex, 1));
    const start = currentStart.subtract(unit, "month");
    const end = currentStart.subtract(1, "day");
    const currentEnd = currentStart.add(unit, "month").subtract(1, "day");
    const currentLabel = unit === 1 ? `${MONTHS[currentStart.month()]} ${currentStart.year()}` : `квартал ${fmt(currentStart)} – ${fmt(currentEnd)}`;
    return { start, end, currentLabel, nextAsOf: currentEnd.add(1, "day") };
};
export const describeBillingRun = (result, billingPeriod) => {
    if (result.invoicesCreated.length > 0) {
        const list = result.invoicesCreated
            .map((invoice) => `${invoice.number} за ${fmt(dayjs(invoice.periodStart))} – ${fmt(dayjs(invoice.periodEnd))}`)
            .join("; ");
        return `Сформирован счёт: ${list}.`;
    }
    const period = lastCompletedPeriod(result.asOf, billingPeriod);
    return (`За ${fmt(period.start)} – ${fmt(period.end)} счёт не создан: начислений нет или счёт за этот период уже выставлен. ` +
        `${period.currentLabel.charAt(0).toUpperCase()}${period.currentLabel.slice(1)} ещё не завершён — чтобы выставить счёт за него, укажите дату «по состоянию на» не раньше ${fmt(period.nextAsOf)}.`);
};
